












































import Vue from 'vue';
import Helpers from '@/utils/Helpers';

export default Vue.extend({
  name: 'HubInput',

  props: {
    appendIcon: {
      type: String,
      default: '',
    },
    appendIconDisabled: {
      type: Boolean,
      default: false,
    },
    appendOuterIcon: {
      type: String,
      default: '',
    },
    backgroundColor: {
      type: String,
      default: '#F5F5F5',
    },
    copy: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    height: {
      type: String,
      default: '53px',
    },
    label: {
      type: String,
      default: '',
    },
    pill: {
      type: Boolean,
      default: false,
    },
    outline: {
      type: Boolean,
      default: false,
    },
    showError: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      copySuccess: false,
    };
  },

  computed: {
    handleAppendIcon() {
      return this.copy ? 'mdi-content-copy' : this.appendIcon;
    },
  },

  methods: {
    async handleClickAppend(event: Event) {
      if (this.copy) {
        await this.handleCopy();
      }

      this.$emit('clickAppend', event);
    },
    handleCopy() {
      Helpers
        .copyToClipboard(this.value)
        .then(() => this.$emit('copied', this.value))
        .then(() => {
          this.copySuccess = true;

          setTimeout(() => { this.copySuccess = false; }, 1500);
        })
        .catch(() => { /**/ });
    },
  },
});
